export function insertOnCondition<T>(item: T, condition: boolean): T[] {
  return condition ? [item] : [];
}
